<template>
  <div id="app">
    <el-container>
      <el-header style="height:80px">
        <el-row>
          <el-col :span="6">
            <div class="grid-content">
              <img style="height: 6em" src="./assets/alt_logo.png">
            </div>
          </el-col>
          <el-col :span="18" style="padding-top:32px;padding-left:200px;">
            <label class="top-navigator" @click="showRow(0)">公司介绍</label>
            <label class="top-navigator" @click="showRow(1)">产品介绍</label>
            <label class="top-navigator" @click="showRow(2)">技术与售后服务保障</label>
            <label class="top-navigator" @click="showRow(3)">联系方式</label>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <el-row>
          <el-carousel indicator-position="outside" v-model="bg_img_list">
            <el-carousel-item v-for="item in bg_img_list" :key="item" style="width: 100%;height: 390px;">
              <img style="max-width: 100%; max-height: 100%;" :src=item />
            </el-carousel-item>
          </el-carousel>
        </el-row>
        <el-row v-show="showCompanyIntroduce">
          <div class="introduce_title">
            公司介绍
          </div>
          <el-col :span="12">
            <div class="company_profile_background">
              <div style="color: white;font-size:2em;font-weight: bold;width: 100%;text-align:left;">COMPANY</div>
              <div style="color: white;font-size:1.8em;width: 100%;text-align:left;">PROFILE</div>
              <div style="color: white;font-size:1.2em;width: 100%;text-align:left;">公司简介</div>
            </div>
            <div>
              <p>
                上海安朗特技术有限公司，有上海交大、上海电力大学、兰州交大和兰州大学硕博士团队发起，是一家专注于智慧变电站设备状态综合监测及其他电力设备检测的创新型科技企业。
                现阶段，公司推出SF6数字化远传微水密度表、GIS和变压器局放监测、电缆的环流和分布式局放监测、高压开关柜状态监测、变压器铁芯电流监测、避雷器/容性设备监测以及SF6
                气体泄漏监测等多个系列产品。公司愿景是成为国内一流、国际知名的智慧变电站监测综合服务商，公司信条是“成就客户、诚信负责、创新卓越”。
              </p>
              <p>
                公司创建初期就吸引了来自国内知名院校的研发、管理、市场和知产专业人员，创建以来团队成员已获得上海市经济与信息化系统突击队、支付宝小程序创新大赛全国十强、上海市
                产业青年创业大赛银奖、上海设计100+、上海市创业立项资助等一系列奖项。公司注重创新及技术壁垒的构建，目前已经申请和授权超20项 专利及软著。
              </p>
              <p>
                现阶段，公司已与国内行业的多家头部企业达成深度合作，公司技术已应用于行业多个项目，其中还有部分海外项目。公司在未来3年将形成完成的智慧变电站综合监测解决方案的研发、
                生产、销售及服务体系，为我国电力行业创造安全、智能、洁净的变电站管理环境贡献自己的力量。在关键的硬件模块、云计算和深度学习等方面，公司将不断的构建自主的技术体系和
                行业壁垒，力争达到国内领先水平。届时，上海安朗特技术有限公司在智慧变电站综合监测领域将占明显的市场份额，并将数字化监测系统的技术广泛运用到变电、配电、输电、用电等
                领域，成为电力数字化时代具有标志性的技术创新型企业。
              </p>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <img style="height: 45em;margin-top:-22px;" src="./assets/service.png">
            </div>
          </el-col>
        </el-row>

        <div v-show="showProductIntroduce">
          <div class="introduce_title">
            产品介绍
          </div>
          <el-collapse v-model="activeName" accordion>
            <el-collapse-item title="APDM-700 局部放电在线监测系统" name="1">
              <el-row>
                <el-row>
                  <el-col :span="12">
                    <div class="apdm700_background">
                      <div style="color: rgb(5, 207, 238);font-size:2em;font-weight: bold;width: 100%;text-align:left;">
                        APDM-700
                      </div>
                      <div style="color: rgb(5, 207, 238);font-size:1.5em;font-weight: bold;width: 100%;text-align:left;">
                        局部放电在线监测系统</div>
                    </div>
                  </el-col>

                  <el-col :span="12">
                    <div>
                      <ul style="text-align:left;">
                        <li>独特优势：装置的通道采用热插拔式模块化多种局放监测任意组合</li>
                        <li>单个装置支持3-20通道的特高频、高频电流、接触式超声波等多种局放监测模式同时采集</li>
                        <li>特高频灵敏度-75dm、高频局放灵敏度5pC、超声波灵敏度1mV、集中局放监测动态范围都大于60dB、线性度优异</li>
                        <li>实时动态三位PRPS和PRPD图谱，具备现场邮箱功能，可保存并回放</li>
                        <li>内置硬件滤噪功能，超声波采用窄波滤波法，特高频可选全通、低通、高通、无需外接滤波器</li>
                        <li>软件可调消噪功能，有效提取真是局放信号，用于准确的分析判断</li>
                        <li>支持PT同步、电源同步及内同步，满足各种现场监测需求</li>
                        <li>超声波通道稳定性高&lt2mV，通道一致性好&lt2mV；特高频通道稳定性高&lt0.5dBm，通道一致性好&lt0.5dBm</li>
                        <li>脉冲数量实时显示，最大值实时显示</li>
                        <li>噪音分类，对比分析，自动准确判断局放类型</li>
                        <li>智能数据管理，可生成测试报告，可手动修改</li>
                      </ul>
                    </div>

                  </el-col>

                </el-row>

                <div style="padding-left:28px;margin-top:20px;">
                  <table>
                    <tr>
                      <th>设备</th>
                      <th>参数名称</th>
                      <th>技术参数</th>
                    </tr>
                    <tr>
                      <td rowspan="8">局放监测装置</td>
                      <td>局部放电通道数量</td>
                      <td>20通道内任意组合</td>
                    </tr>
                    <tr>
                      <td>局部放电监测动态范围</td>
                      <td>60dB</td>
                    </tr>
                    <tr>
                      <td>高频局部放电检测频率带宽</td>
                      <td>0.1MHz-30MHz</td>
                    </tr>
                    <tr>
                      <td>特高频局部放电检测频率带宽</td>
                      <td>300MHZ-1500MHZ</td>
                    </tr>
                    <tr>
                      <td>支持图谱功能</td>
                      <td>实时动态PRPS和PRPD图谱</td>
                    </tr>
                    <tr>
                      <td>局放判断</td>
                      <td>自动准确判断局放类别</td>
                    </tr>
                    <tr>
                      <td>通道一致性</td>
                      <td>通道一致性&lt1dB</td>
                    </tr>
                    <tr>
                      <td>工作环境温度</td>
                      <td>-40 ~ +70 &#176;C</td>
                    </tr>
                    <tr>
                      <td rowspan="4">高频电流局放传感器</td>
                      <td>HRCT频率范围</td>
                      <td>0.1MHz - 30MHz</td>
                    </tr>
                    <tr>
                      <td>灵敏度</td>
                      <td>&GreaterEqual;12mV/mA</td>
                    </tr>
                    <tr>
                      <td>输出端接口</td>
                      <td>BNC</td>
                    </tr>
                    <tr>
                      <td>信号输出阻抗</td>
                      <td>50 &#937;</td>
                    </tr>
                    <tr>
                      <td rowspan="4">特高频局放传感器</td>
                      <td>UHF频率范围</td>
                      <td>300MHz - 1500MHz</td>
                    </tr>
                    <tr>
                      <td>平均等效高度</td>
                      <td>&GreaterEqual;12mm</td>
                    </tr>
                    <tr>
                      <td>输出端接口</td>
                      <td>N型</td>
                    </tr>
                    <tr>
                      <td>信号输出阻抗</td>
                      <td>50 &#937;</td>
                    </tr>
                  </table>
                </div>
              </el-row>
            </el-collapse-item>

            <el-collapse-item title="AGM-700 SF6数字化远传微水密度监测系统" name="2">
              <el-row>
                <el-row>
                  <el-col :span="12">
                    <div class="agm700_background">
                      <div style="color: rgb(5, 207, 238);font-size:2em;font-weight: bold;width: 100%;text-align:left;">
                        AGM-700
                      </div>
                      <div style="color: rgb(5, 207, 238);font-size:1.5em;font-weight: bold;width: 100%;text-align:left;">
                        SF6数字化远传微水密度监测系统</div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div>
                      <ul style="text-align:left;">
                        <li>实时监测高压开关设备中SF6气体的温度、压力、密度、湿度PPM值</li>
                        <li>机械表部分实现密度压力报警和闭锁</li>
                        <li>实现高压开关中SF6气体泄漏低压报警、闭锁预警，水份超标报警功能</li>
                        <li>系统采用RS485总线通讯，将监测数据实时上传至监控中心</li>
                        <li>系统可按设定时间频率采样存储数据，系统实时监测记录所有数据</li>
                        <li>系统自动绘制SF6气体压力、密度、和湿度PPM值的趋势图</li>
                        <li>系统自动记录报警状态的各项参数，供维护参考，通知检修维护</li>
                        <li>现场监测仪表采用一体式设计，防水、防尘，抗电磁干扰，安装使用方便</li>
                      </ul>
                    </div>
                  </el-col>
                </el-row>

                <div style="padding-left:28px;">
                  <table>
                    <tr>
                      <td rowspan="7">测量范围</td>
                      <td>密度范围</td>
                      <td>0~100 kg/m3</td>
                    </tr>
                    <tr>
                      <td>P20</td>
                      <td>0到1.4Mpa（绝压）</td>
                    </tr>
                    <tr>
                      <td>压力范围</td>
                      <td>0到1.4Mpa（绝压）</td>
                    </tr>
                    <tr>
                      <td>过载压力</td>
                      <td>&lt;1.5Mpa</td>
                    </tr>
                    <tr>
                      <td>温度范围</td>
                      <td>-40℃~+80℃</td>
                    </tr>
                    <tr>
                      <td>露点</td>
                      <td>-50℃~+20℃</td>
                    </tr>
                    <tr>
                      <td>PPM值</td>
                      <td>50~10000PPM</td>
                    </tr>
                    <tr>
                      <td rowspan="6">电气性能（有线）</td>
                      <td>工作电压</td>
                      <td>18~24VDC</td>
                    </tr>
                    <tr>
                      <td>功 率</td>
                      <td>&lt;1W</td>
                    </tr>
                    <tr>
                      <td>有线通讯</td>
                      <td>RS485接口</td>
                    </tr>
                    <tr>
                      <td>通讯协议</td>
                      <td>Modbus</td>
                    </tr>
                    <tr>
                      <td>传输速度</td>
                      <td>9600bps</td>
                    </tr>
                    <tr>
                      <td>传输距离</td>
                      <td>1Km</td>
                    </tr>
                    <tr>
                      <td rowspan="5">测量精度</td>
                      <td>压力精度</td>
                      <td>±0.3%FS(0. 5级)</td>
                    </tr>
                    <tr>
                      <td>温度精度</td>
                      <td>±0.2%FS(0. 5级)</td>
                    </tr>
                    <tr>
                      <td>P20精度</td>
                      <td>±0.5%FS(1级)</td>
                    </tr>
                    <tr>
                      <td>露点精度</td>
                      <td>±3 ℃</td>
                    </tr>
                    <tr>
                      <td>长期稳定性</td>
                      <td>±0.3%FS</td>
                    </tr>
                    <tr>
                      <td rowspan="6">电气性能（有线）</td>
                      <td>工作电压</td>
                      <td>18~24VDC</td>
                    </tr>
                    <tr>
                      <td>功 率</td>
                      <td>&lt;1W</td>
                    </tr>
                    <tr>
                      <td>有线通讯</td>
                      <td>RS485接口</td>
                    </tr>
                    <tr>
                      <td>通讯协议</td>
                      <td>Modbus</td>
                    </tr>
                    <tr>
                      <td>传输速度</td>
                      <td>9600bps</td>
                    </tr>
                    <tr>
                      <td>传输距离</td>
                      <td>1Km</td>
                    </tr>
                    <tr>
                      <td rowspan="4">机械性能</td>
                      <td>漏气率</td>
                      <td>≤1×10-8mbar.l/s（氦气检测）</td>
                    </tr>
                    <tr>
                      <td>防护等级</td>
                      <td>IP65</td>
                    </tr>
                    <tr>
                      <td>抗冲击性能</td>
                      <td>500m/s2</td>
                    </tr>
                    <tr>
                      <td>抗震性能</td>
                      <td>200 m/s2</td>
                    </tr>
                    <tr>
                      <td rowspan="5">其他指标</td>
                      <td>环境温度</td>
                      <td>-40℃~+80℃</td>
                    </tr>
                    <tr>
                      <td>存储温度</td>
                      <td>-50℃~+100℃</td>
                    </tr>
                    <tr>
                      <td>相对湿度</td>
                      <td>0~95%RH</td>
                    </tr>
                    <tr>
                      <td>耐压测试</td>
                      <td>﹥800 VDC</td>
                    </tr>
                    <tr>
                      <td>绝缘电阻测试</td>
                      <td>﹥2000MΩ</td>
                    </tr>
                  </table>
                </div>
              </el-row>
            </el-collapse-item>

            <el-collapse-item title="APDM-900 开关柜在线监测系统" name="3">
              <el-row>
                <el-row>
                  <el-col :span="12">
                    <div class="apdm900_background">
                      <div style="color: rgb(5, 207, 238);font-size:2em;font-weight: bold;width: 100%;text-align:left;">
                        APDM-900
                      </div>
                      <div style="color: rgb(5, 207, 238);font-size:1.5em;font-weight: bold;width: 100%;text-align:left;">
                        开关柜在线监测系统</div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div>
                      <ul style="text-align:left;">
                        <li>可在电网设备带点运行情况下进行现场安装和维护，不影响电网设备运行和供电可靠性</li>
                        <li>智能传感器采用微型化、模块化、高性能、低功率设计，内置电池容量可支持工作5年以上</li>
                        <li>多种局部放电监测手段：UHR、AE、TEV、高频电流、臭氧、温度等</li>
                        <li>“有线有源”、“无线无源”、等多种部署方案</li>
                        <li>传感器支持国网输变电物联网传感器数据通信规约、loraWAN等多种无线通信规约，支持Modbus等有线通信规约</li>
                        <li>搭载电力设备状态智能监测系统软件，完备的数据分析功能，可自由选择时间、参数、多测点的历史趋势分析以及横向对比分析；同时集成监测数据智能诊断算法，诊断准确率达90%以上</li>
                        <li>智能监测系统支持就地部署、云端部署以及私有化部署，可实现365 x 24的稳定运行</li>
                        <li>具备传感器和监测主机具备边缘计算功能，根据各种参数历史数据综合判断进行预警、告警、正常诊断</li>
                      </ul>
                    </div>
                  </el-col>
                </el-row>



                <div style="padding-left:28px;">
                  <table>
                    <tr>
                      <th colspan="2">项目</th>
                      <th>技术参数</th>
                    </tr>
                    <tr>
                      <td rowspan="4">对接感知层无线参数</td>
                      <td>局部无线接口</td>
                      <td>Lora通信，LoraWan协议</td>
                    </tr>
                    <tr>
                      <td>管理无线局放传感器数量</td>
                      <td>&le;100只</td>
                    </tr>
                    <tr>
                      <td>测温无线接口</td>
                      <td>433M</td>
                    </tr>
                    <tr>
                      <td>管理无线测温传感器数量</td>
                      <td>&le;252只</td>
                    </tr>
                    <tr>
                      <td rowspan="3">对接平台端通信参数</td>
                      <td>通信接口</td>
                      <td>网口、4g</td>
                    </tr>
                    <tr>
                      <td>主机组网数量</td>
                      <td>&le;128台</td>
                    </tr>
                    <tr>
                      <td>通信协议</td>
                      <td>MQTT</td>
                    </tr>
                    <tr>
                      <td colspan="2">屏幕尺寸</td>
                      <td>13.3英寸</td>
                    </tr>
                    <tr>
                      <td colspan="2">硬盘容量</td>
                      <td>按需配置</td>
                    </tr>
                    <tr>
                      <td colspan="2">接口</td>
                      <td>LAN*1/LoRa*4/4g*1</td>
                    </tr>
                    <tr>
                      <td colspan="2">整机功耗</td>
                      <td>&le;5W</td>
                    </tr>
                    <tr>
                      <td colspan="2">工作温度</td>
                      <td>-10℃~+70℃</td>
                    </tr>
                    <tr>
                      <td colspan="2">工作湿度</td>
                      <td>90%RH，不结露，无腐蚀</td>
                    </tr>
                    <tr>
                      <td colspan="2">防护等级</td>
                      <td>IP20</td>
                    </tr>
                    <tr>
                      <td colspan="2">整机尺寸</td>
                      <td>420mm*290mm*120mm</td>
                    </tr>
                    <tr>
                      <td colspan="2">整机重量</td>
                      <td>3KG</td>
                    </tr>
                    <tr>
                      <td colspan="2">安装方式</td>
                      <td>壁挂安装</td>
                    </tr>
                  </table>
                </div>
              </el-row>
            </el-collapse-item>

            <el-collapse-item title="局放超声波暂固态地电压二合一传感器" name="4">
              <el-row>
                <el-col :span="10">
                  <div class="small_product_img_jufangerheyi">
                  </div>
                </el-col>
                <el-col :span="14">
                  <label class="small_product_title">局放超声波暂固态地电压二合一传感器</label>
                  <table>
                    <tr>
                      <th>项目</th>
                      <th>技术参数</th>
                    </tr>
                    <tr>
                      <td>TEV检测带宽</td>
                      <td>3 ~ 100MHz</td>
                    </tr>
                    <tr>
                      <td>TEV检测动态v范围</td>
                      <td>0 ~ 60dBmV</td>
                    </tr>
                    <tr>
                      <td>超声检测频带</td>
                      <td>40 &plusmn; 1kHZ</td>
                    </tr>
                    <tr>
                      <td>超声检测动态v范围</td>
                      <td>-10 ~ 70dBuV</td>
                    </tr>
                    <tr>
                      <td>供电方式</td>
                      <td>内置锂亚电池</td>
                    </tr>
                    <tr>
                      <td>通信协议</td>
                      <td>国网输变电设备物联网传感器数据通信规约、LoRaWAN</td>
                    </tr>
                    <tr>
                      <td>工频同步</td>
                      <td>内同步/无线同步</td>
                    </tr>
                    <tr>
                      <td>续航时间</td>
                      <td>不小于5年（采样时间间隔1小时1次）</td>
                    </tr>
                    <tr>
                      <td>通信传输距离</td>
                      <td>无线传输不小于200m</td>
                    </tr>
                    <tr>
                      <td>传感器重量</td>
                      <td>0.5Kg</td>
                    </tr>
                    <tr>
                      <td>传感器尺寸</td>
                      <td>100 * 121.8 * 60mm（长*宽*高）</td>
                    </tr>
                    <tr>
                      <td>防护等级</td>
                      <td>IP66</td>
                    </tr>
                    <tr>
                      <td>工作温度</td>
                      <td>-40℃~+85℃</td>
                    </tr>
                    <tr>
                      <td>工作湿度</td>
                      <td>95%，不凝露</td>
                    </tr>
                  </table>
                </el-col>
              </el-row>
            </el-collapse-item>

            <el-collapse-item title="局放特高频智能传感器" name="5">
              <el-row>

                <el-col :span="10">
                  <div class="small_product_img_tegaopin">
                  </div>
                </el-col>
                <el-col :span="14">
                  <label class="small_product_title">局放特高频智能传感器</label>
                  <table>
                    <tr>
                      <th>项目</th>
                      <th>技术参数</th>
                    </tr>
                    <tr>
                      <td>UHF检测带宽</td>
                      <td>300 ~ 1500MHz</td>
                    </tr>
                    <tr>
                      <td>UHF检测动态范围</td>
                      <td>-80 ~ -5dBmV</td>
                    </tr>
                    <tr>
                      <td>平均等效高度</td>
                      <td>&ge;10mm</td>
                    </tr>
                    <tr>
                      <td>供电方式</td>
                      <td>内置锂亚电池</td>
                    </tr>
                    <tr>
                      <td>通信协议</td>
                      <td>国网输变电设备物联网传感器数据通信规约、LoRaWAN</td>
                    </tr>
                    <tr>
                      <td>工频同步</td>
                      <td>内同步/无线同步</td>
                    </tr>
                    <tr>
                      <td>数据图谱</td>
                      <td>PRPS、累计PRPS</td>
                    </tr>
                    <tr>
                      <td>续航时间</td>
                      <td>不小于5年（采样时间间隔1小时1次）</td>
                    </tr>
                    <tr>
                      <td>通信传输距离</td>
                      <td>无线传输不小于200m</td>
                    </tr>
                    <tr>
                      <td>传感器重量</td>
                      <td>1Kg</td>
                    </tr>
                    <tr>
                      <td>传感器尺寸</td>
                      <td>177.5 * 87 * 95.2mm（长*宽*高）</td>
                    </tr>
                    <tr>
                      <td>安装方式</td>
                      <td>无线：磁吸 有线：前端（法兰）/后端卡钩</td>
                    </tr>
                    <tr>
                      <td>防护等级</td>
                      <td>IP67</td>
                    </tr>
                    <tr>
                      <td>工作温度</td>
                      <td>-40℃~+85℃</td>
                    </tr>
                    <tr>
                      <td>工作湿度</td>
                      <td>95%，不凝露</td>
                    </tr>
                  </table>
                </el-col>
              </el-row>
            </el-collapse-item>

            <el-collapse-item title="高频电流局放智能传感器" name="6">
              <el-row>
                <el-col :span="10">
                  <div class="small_product_img_tiexin">
                  </div>
                </el-col>
                <el-col :span="14">
                  <label class="small_product_title">高频电流局放智能传感器</label>
                  <table>
                    <tr>
                      <th>项目</th>
                      <th>技术参数</th>
                    </tr>
                    <tr>
                      <td>检测类型</td>
                      <td>高频电流</td>
                    </tr>
                    <tr>
                      <td>传输阻抗</td>
                      <td>通道内最大转移阻抗20V/A</td>
                    </tr>
                    <tr>
                      <td>检测频带</td>
                      <td>30 - 100mHZ</td>
                    </tr>
                    <tr>
                      <td>动态v范围</td>
                      <td>1mV - 5V</td>
                    </tr>
                    <tr>
                      <td>供电方式</td>
                      <td>
                        有线版本：AC220V交流供电、DC24V直流供电<br />
                        无线版本：内置锂亚电池
                      </td>
                    </tr>
                    <tr>
                      <td>通信协议</td>
                      <td>国网输变电设备物联网传感器数据通信规约、LoRaWAN</td>
                    </tr>
                    <tr>
                      <td>工频同步</td>
                      <td>核相孔电源同步/内同步/无线同步</td>
                    </tr>
                    <tr>
                      <td>通信传输距离</td>
                      <td>无线传输不小于200m</td>
                    </tr>
                    <tr>
                      <td>传感器重量</td>
                      <td>0.6Kg</td>
                    </tr>
                    <tr>
                      <td>传感器尺寸</td>
                      <td>80 * 65 * 40mm（长*宽*高）</td>
                    </tr>
                    <tr>
                      <td>防护等级</td>
                      <td>IP67</td>
                    </tr>
                    <tr>
                      <td>工作温度</td>
                      <td>-40℃~+85℃</td>
                    </tr>
                    <tr>
                      <td>工作湿度</td>
                      <td>95%，不凝露</td>
                    </tr>
                  </table>
                </el-col>
              </el-row>
            </el-collapse-item>

            <el-collapse-item title="高频电流局放智能传感器" name="7">
              <el-row>
                <label class="small_product_title">高频电流局放智能传感器</label>
                <ul style="text-align:left;">
                  <li>采用穿心式互感器，与二次回路完全隔离，安全性高</li>
                  <li>采用分布式测量结构，即就地测量、数字传输，规约符合DL/T860标准</li>
                  <li>可带电安装，即不需要主设备停电安装，方便、快捷的接入系统</li>
                  <li>采用数字滤波方法，摒除模拟滤波器带来的“零飘问题”</li>
                  <li>采用高精度有源零磁通传感器，根据被测量电流大小智能选择调理电路及放大倍数，有效提高了测量精度</li>
                  <li>具有现场实时温度湿度测量功能</li>
                </ul>
                <table>
                  <tr>
                    <th colspan="2">项目</th>
                    <th>技术参数</th>
                  </tr>
                  <tr>
                    <td rowspan="4">工作环境</td>
                    <td>工作电压</td>
                    <td>交流220V &PlusMinus; 10%，50Hz</td>
                  </tr>
                  <tr>
                    <td>功耗</td>
                    <td>额定电压下&lt;5W</td>
                  </tr>
                  <tr>
                    <td>工作环境温度</td>
                    <td>-40℃~+120℃</td>
                  </tr>
                  <tr>
                    <td>工作环境湿度</td>
                    <td>&le;95%</td>
                  </tr>
                  <tr>
                    <td rowspan="4">检测参数指标</td>
                    <td>测量范围</td>
                    <td>1mA ~ 30A</td>
                  </tr>
                  <tr>
                    <td>测量精度</td>
                    <td>&PlusMinus;1%或1mA</td>
                  </tr>
                  <tr>
                    <td>测量分别率</td>
                    <td>0.1mA</td>
                  </tr>
                  <tr>
                    <td>通讯方式</td>
                    <td>RS485</td>
                  </tr>
                </table>
              </el-row>
            </el-collapse-item>

            <el-collapse-item title="避雷器在线监测装置" name="8">
              <el-row>
                <label class="small_product_title">避雷器在线监测装置</label>
                <ul style="text-align:left;">
                  <li>采用高精度有源零磁通穿心式互感器，根据被测电流大小自动选择放大倍数，实现高精度测量</li>
                  <li>采用动态向量补偿算法，实现高精度测量信号分析</li>
                  <li>采用数字滤波方法，摒除模拟滤波器带来的“零飘问题”</li>
                  <li>采用分布式测量结构，即就地测量、数字传输</li>
                  <li>可带电安装，即不需要主设备停电安装，方便、快捷的接入系统</li>
                </ul>
                <div>
                  技术参数表
                </div>
                <table>
                  <tr>
                    <th>项目</th>
                    <th>技术参数</th>
                  </tr>
                  <tr>
                    <td>测量范围</td>
                    <td>0.01mA ~ 150mA</td>
                  </tr>
                  <tr>
                    <td>测量精度</td>
                    <td>&PlusMinus;1%</td>
                  </tr>
                  <tr>
                    <td>累计次数记录</td>
                    <td>0 ~ 255 年月日时分秒</td>
                  </tr>
                  <tr>
                    <td>测量阻性电流精度</td>
                    <td>误差&lt;&PlusMinus;(标准读数1%&PlusMinus;5uA)</td>
                  </tr>
                  <tr>
                    <td>通信接口</td>
                    <td>Modbus私有链接到IDE/CAN</td>
                  </tr>
                  <tr>
                    <td>工作环境</td>
                    <td>-40℃~+85℃</td>
                  </tr>
                  <tr>
                    <td>防护等级</td>
                    <td>IP68</td>
                  </tr>
                  <tr>
                    <td>安装方式</td>
                    <td>支架螺丝固定</td>
                  </tr>
                  <tr>
                    <td>外壳材质</td>
                    <td>304不锈钢</td>
                  </tr>
                </table>
                <div>
                  其他技术参数
                </div>
                <table>
                  <tr>
                    <td colspan="2">系统容量</td>
                    <td>就地模块80个</td>
                  </tr>
                  <tr>
                    <td colspan="2">监测周期</td>
                    <td>出场设置1小时</td>
                  </tr>
                  <tr>
                    <td colspan="2">最短监测周期</td>
                    <td>5分钟</td>
                  </tr>
                  <tr>
                    <td colspan="2">CAN网结构网络速率</td>
                    <td>&lt;500kbps</td>
                  </tr>
                  <tr>
                    <td colspan="2">RS485结构网络速率</td>
                    <td>&le;2400bps</td>
                  </tr>
                  <tr>
                    <td colspan="2">系统生存周期</td>
                    <td>&gt;3年以上</td>
                  </tr>
                  <tr>
                    <td rowspan="2">系统平均无故障工作时间(MTBF)</td>
                    <td>户内</td>
                    <td>&lt;5 x 104小时</td>
                  </tr>
                  <tr>
                    <td>户外</td>
                    <td>&lt;3 x 104小时</td>
                  </tr>
                </table>
                <div class="small_product_img_bilei"></div>

              </el-row>
            </el-collapse-item>

            <el-collapse-item title="断路器机械特性在线监测系统" name="9">
              <el-row>
                <label class="small_product_title">断路器机械特性在线监测系统</label>
                <ul style="text-align:left;">
                  <li>采用前端配置6路电流监测通道，其中3路交直流监测通道分别用于监测分合闸线圈电流和储能电机电流，另外3路交流检测通道用于检测电流互感器二次电流</li>
                  <li>上位机对测量数据进行处理，通过采集的电流互感器二次侧电流判断断路器主触头的分合闸时刻，从而计算分合闸时间、分合闸通气性等分合闸过程中的特征参数，对断路器动作状态进行初步判断</li>
                  <li>能够监测储能电机电流数据，对储能机械链路及储能电机的电器回路状态进行监测</li>
                  <li>上位机能够对断路器的分合闸次数，电机储能次数进行统计，对断路器的寿命进行初步考核</li>
                  <li>上位机对设备在不同时期的测量数据进行叠加对比显示，对各种特征参数绘制趋势图谱，便于对断路器状态的发展趋势进行判断</li>
                  <li>电流传感器和霍尔传感器均采用开合式结构，便于现场安装，不影响高压设备运行，也不会改变设备内部电路</li>
                  <li>监测前端和上位机软件之间通过485总线或则LORA无线通讯方式传输数据，既可以使用新建变电站布置总线的通讯方式，也可以满足已运行电站现场改造项目</li>
                </ul>
                <div>
                  传感器及相关参数
                </div>
                <table>
                  <tr>
                    <th>通道类型</th>
                    <th>通道信号</th>
                    <th>测量范围</th>
                    <th>测量精度</th>
                    <th>通道数量</th>
                  </tr>
                  <tr>
                    <td rowspan="2">直流</td>
                    <td>分合闸线圈电流</td>
                    <td rowspan="2">0 ~ &PlusMinus; 10A(量程可选)</td>
                    <td rowspan="2">0.5 ~ &PlusMinus; 15A，&le;1%</td>
                    <td>2</td>
                  </tr>
                  <tr>
                    <td>储能电机电流</td>
                    <td>1</td>
                  </tr>
                  <tr>
                    <td>交流</td>
                    <td>互感二次侧电流（ABC三组）</td>
                    <td>0 ~ 10A(量程可选)</td>
                    <td>0.5 ~ &PlusMinus; 10A，&le;1%</td>
                    <td>3</td>
                  </tr>
                  <tr>
                    <td>脉冲</td>
                    <td>行程</td>
                    <td>0/5V(选配)</td>
                    <td>0.2&deg;</td>
                    <td>1</td>
                  </tr>
                  <tr>
                    <td>开关量</td>
                    <td>分合闸信号</td>
                    <td>0/1(选配)</td>
                    <td>0.1ms</td>
                    <td>2</td>
                  </tr>
                </table>
                <table>
                  <tr>
                    <td>电源</td>
                    <td>前端：AC85V-264V,3W</td>
                    <td colspan="2">通讯方式</td>
                  </tr>
                  <tr>
                    <td>上位机</td>
                    <td>AC85V-264V,20W</td>
                    <td>前端和上位机</td>
                    <td>RS485或LORA无线通讯</td>
                  </tr>
                  <tr>
                    <td>工作环境</td>
                    <td>温度-40℃~+85℃</td>
                    <td>上位机和服务器</td>
                    <td>光纤、网线、RS485等有线通讯方式</td>
                  </tr>
                </table>
                <div class="small_product_img_jixietexing"></div>
              </el-row>
            </el-collapse-item>

          </el-collapse>

        </div>



        <el-row v-show="showServiceIntroduce" style="text-align: left;line-height: 40px;">
          <div class="introduce_title">
            技术与售后服务保障
          </div>
          <!-- <div class="small_product_img_shouhou"></div> -->
          <el-row>
            <el-col :span="12">
              <div class="left_circle_backgrond">
                <div style="margin-top:60px;margin-left: 60px;color: white;font-size:1.2em;">
                  <div>PRE-SALES</div>
                  <div>售前 <i class="el-icon-caret-right"></i> </div>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div style="color: rgb(5, 207, 238);font-size: 1.4em;">TECHNICAL SUPPORT</div>
              <div style="color: rgb(5, 207, 238);font-size: 1.8em;font-weight: bold;">技术支持</div>
              <div style="font-weight: bold;">技术对接咨询服务</div>
              <div>technical docking consulting services</div>
              <div style="font-weight: bold;">行业应用服务案例</div>
              <div>industry application service solutions</div>
              <div style="font-weight: bold;">产品OEM定制开发</div>
              <div>product OEM custom development</div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" style="padding-left:100px;">
              <div style="color: rgb(5, 207, 238);font-size: 1.4em;">APPLICATION SERVICES</div>
              <div style="color: rgb(5, 207, 238);font-size: 1.8em;font-weight: bold;">应用服务</div>
              <div style="font-weight: bold;">保障快交准交服务</div>
              <div>ensure fast delivery and punctual delivery services</div>
              <div style="font-weight: bold;">全程应用技术指导</div>
              <div>technial application guidance throughout the process</div>
              <div style="font-weight: bold;">提供安装调试服务</div>
              <div>provide installation and commissioning services</div>
            </el-col>
            <el-col :span="12">
              <div class="right_circle_backgrond">
                <div style="margin-top:60px;margin-left: 60px;color: white;font-size:1.2em;">
                  <div>SELLING</div>
                  <div><i class="el-icon-caret-left"></i> 售中</div>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <div class="left_circle_backgrond">
                <div style="margin-top:60px;margin-left: 40px;color: white;font-size:1.2em;">
                  <div>AFTER-SALES</div>
                  <div>售后<i class="el-icon-caret-right"></i> </div>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div style="color: rgb(5, 207, 238);font-size: 1.4em;">PROFESSIONAL SERVICE</div>
              <div style="color: rgb(5, 207, 238);font-size: 1.8em;font-weight: bold;">专业服务</div>
              <div style="font-weight: bold;">快速响应专业服务</div>
              <div>quick response professional services</div>
              <div style="font-weight: bold;">提供产品升级解决方案</div>
              <div>provide product upgrade solutions</div>
              <div style="font-weight: bold;">提供售后维修保养服务</div>
              <div>provice after-sales maintenance service</div>
            </el-col>
          </el-row>

        </el-row>

        <el-row v-show="showCommunicateInfoIntroduce">
          <div class="introduce_title">
            联系方式
          </div>
          <el-col :span="12">
            <div class="contract_area">
              <i class="el-icon-phone-outline"></i>
              <lable>周经理：</lable>
              <lable>13307107577, 15871752137</lable>
              <br/>
              <i class="el-icon-message"></i>
              <lable>邮&nbsp;&nbsp;&nbsp;&nbsp;箱：</lable>
              <lable>554157580.com</lable>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="contract_area">
              <i class="el-icon-phone-outline"></i>
              <lable>许经理：</lable>
              <lable>15021080497</lable>
              <br/>
              <i class="el-icon-message"></i>
              <lable>邮&nbsp;&nbsp;&nbsp;&nbsp;箱：</lable>
              <lable>15021080497@139.com</lable>
            </div>
          </el-col>

        </el-row>

      </el-main>

      <el-footer style="background-color:rgb(132, 161, 165);height:30px;padding-top: 3px;">
        <label>上海安朗特技术有限公司 &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</label>
        <label>统一社会信用代码：91310112MABXDJ1K&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</label>
        <a href="http://beian.miit.gov.cn/"> 沪ICP备2023024593号</a>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bg_img_list: [require('./assets/bg1.jpg'), require('./assets/bg2.jpg'), require('./assets/bg3.jpg')],
      showCompanyIntroduce: true,
      showProductIntroduce: true,
      showServiceIntroduce: true,
      showCommunicateInfoIntroduce: true,
      activeName: '1'
    }
  },
  methods: {
    startHacking() {
      this.$notify({
        title: 'It works!',
        type: 'success',
        message: 'We\'ve laid the ground work for you. It\'s time for you to build something epic!',
        duration: 5000
      })
    },

    showRow(i) {
      //console.log('show index'+index);
      if (i === 0) {
        this.showCompanyIntroduce = true;
        this.showProductIntroduce = false;
        this.showServiceIntroduce = false;
        this.showCommunicateInfoIntroduce = false;
      } else if (i === 1) {
        this.showCompanyIntroduce = false;
        this.showProductIntroduce = true;
        this.showServiceIntroduce = false;
        this.showCommunicateInfoIntroduce = false;
      } else if (i === 2) {
        this.showCompanyIntroduce = false;
        this.showProductIntroduce = false;
        this.showServiceIntroduce = true;
        this.showCommunicateInfoIntroduce = false;
      } else if (i === 3) {
        this.showCompanyIntroduce = false;
        this.showProductIntroduce = false;
        this.showServiceIntroduce = false;
        this.showCommunicateInfoIntroduce = true;
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Helvetica, sans-serif;
  text-align: center;
}

.el-row {
  margin-bottom: 6px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
  height: 100px;
  padding-left: 40px
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.top-navigator {
  font-size: 1.5em;
  margin-left: 60px;
}

.el-carousel__container {
  height: 390px;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 390px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.company_profile_background {
  box-sizing: border-box;
  height: 20em;
  padding-top: 10em;
  padding-left: 5em;
  background-image: url("./assets/alt_company_description.jpg");
  background-size: cover;
  /* 背景图像等比例缩放，尽量填充容器 */
  background-repeat: no-repeat;
  /* 防止背景图像重复 */
  background-position: center center;
  /* 背景图像居中显示 */
}

.apdm700_background {
  box-sizing: border-box;
  height: 24em;
  width: 44em;
  padding-top: 1em;
  padding-left: 2em;
  background-image: url("./assets/apdm-700.png");
  background-size: cover;
  /* 背景图像等比例缩放，尽量填充容器 */
  background-repeat: no-repeat;
  /* 防止背景图像重复 */
  background-position: center center;
  /* 背景图像居中显示 */
}

.agm700_background {
  box-sizing: border-box;
  height: 24em;
  width: 40em;
  padding-top: 1em;
  padding-left: 2em;
  background-image: url("./assets/agm-700.png");
  background-size: cover;
  /* 背景图像等比例缩放，尽量填充容器 */
  background-repeat: no-repeat;
  /* 防止背景图像重复 */
  background-position: center center;
  /* 背景图像居中显示 */
}

.apdm900_background {
  box-sizing: border-box;
  height: 24em;
  padding-top: 1em;
  padding-left: 2em;
  background-image: url("./assets/apdm-900.png");
  background-size: cover;
  /* 背景图像等比例缩放，尽量填充容器 */
  background-repeat: no-repeat;
  /* 防止背景图像重复 */
  background-position: center center;
  /* 背景图像居中显示 */
}

.small_product_title {
  color: rgb(5, 207, 238);
  font-size: 1.2em;
  font-weight: bold;
  width: 100%;
  text-align: left;
  margin-top: 20px;
  margin-bottom: 20px;
}

.small_product_img_jufangerheyi {
  box-sizing: border-box;
  height: 18em;
  width: 20em;
  margin-top: 6em;
  margin-left: 7em;
  padding-left: 1em;
  background-image: url("./assets/jufangerheyi.png");
  background-size: cover;
  /* 背景图像等比例缩放，尽量填充容器 */
  background-repeat: no-repeat;
  /* 防止背景图像重复 */
  background-position: center center;
  /* 背景图像居中显示 */
}

.small_product_img_tegaopin {
  box-sizing: border-box;
  height: 12em;
  width: 20em;
  margin-top: 11em;
  margin-left: 7em;
  padding-left: 1em;
  background-image: url("./assets/tegaopin.png");
  background-size: cover;
  /* 背景图像等比例缩放，尽量填充容器 */
  background-repeat: no-repeat;
  /* 防止背景图像重复 */
  background-position: center center;
  /* 背景图像居中显示 */
}

.small_product_img_tiexin {
  box-sizing: border-box;
  height: 16em;
  width: 20em;
  margin-top: 11em;
  margin-left: 7em;
  padding-left: 1em;
  background-image: url("./assets/tiexin.png");
  background-size: cover;
  /* 背景图像等比例缩放，尽量填充容器 */
  background-repeat: no-repeat;
  /* 防止背景图像重复 */
  background-position: center center;
  /* 背景图像居中显示 */
}

.small_product_img_bilei {
  box-sizing: border-box;
  height: 16em;
  width: 50em;
  margin: auto;
  margin-top: 1em;
  padding-left: 1em;
  background-image: url("./assets/bilei.png");
  background-size: cover;
  /* 背景图像等比例缩放，尽量填充容器 */
  background-repeat: no-repeat;
  /* 防止背景图像重复 */
  background-position: center center;
  /* 背景图像居中显示 */
}

.small_product_img_jixietexing {
  box-sizing: border-box;
  height: 26em;
  width: 48em;
  margin: auto;
  margin-top: 1em;
  padding-left: 1em;
  background-image: url("./assets/jiexietexing.png");
  background-size: cover;
  /* 背景图像等比例缩放，尽量填充容器 */
  background-repeat: no-repeat;
  /* 防止背景图像重复 */
  background-position: center center;
  /* 背景图像居中显示 */
}

.small_product_img_shouhou {
  box-sizing: border-box;
  height: 40em;
  margin-top: 1em;
  padding-left: 1em;
  background-image: url("./assets/shouhou.png");
  background-size: cover;
  /* 背景图像等比例缩放，尽量填充容器 */
  background-repeat: no-repeat;
  /* 防止背景图像重复 */
  background-position: center center;
  /* 背景图像居中显示 */
}

.left_circle_backgrond {
  background-color: rgb(5, 207, 238);
  border-radius: 50%;
  height: 200px;
  width: 200px;
  float: right;
  margin-top: 80px;
  margin-right: 100px;
}

.right_circle_backgrond {
  background-color: rgb(5, 207, 238);
  border-radius: 50%;
  height: 200px;
  width: 200px;
  float: left;
  margin-top: 80px;
  margin-left: 100px;
}

.el-collapse-item__header {
  text-align: left;
  font-size: 23px;
}
.introduce_title{
  text-align:center;
  font-size:30px;
  color: rgb(24, 162, 184);
  margin-top:20px;
  margin-bottom:20px;
}
.contract_area{
  height:30px;
  width:310px;
  margin:auto;
  text-align: left;
  padding-top:40px;
  padding-left: 10px;
  padding-bottom:40px;
  border:1px solid rgb(24, 162, 184);
}

p {
  text-indent: 2em;
  text-align: left;
}

li {
  margin-bottom: 10px;
  font-size: 13px;
}

table {
  border-collapse: collapse;
  width: 100%;
}

tr {
  width: 100%;
}

td,
th {
  border: 1px solid black;
}
</style>



// WEBPACK FOOTER //
// src/App.vue